import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlatformLocation } from '@angular/common';
@Component({
  selector: 'app-pay-go-list-modal',
  templateUrl: './pay-go-list-modal.component.html',
  styleUrl: './pay-go-list-modal.component.scss'
})
export class PayGoListModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<any>,
    private location: PlatformLocation,
  ) {
    location.onPopState(() => { this.beforeClose(); this.dialog.close(); });
  }
  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  public closeDialog(): void {
    this.beforeClose();
    this.dialog.close(false);
  }
}
